





import Vue from 'vue'
import Poll from '@/models/polls/Poll'
import {CONF_BASE_URL} from '@/constants'
import config from '@/config'

export default Vue.extend({
  name: 'pollPageStatusBlock',
  props: {
    scope: {} as () => {poll: Poll},
  },
  computed: {
    ansTotal (): number {
      return this.scope.poll.getAnsTotal()
    }
  },
  methods: {
    async getPollResults() {
      try {
        var windowReference = window.open();
        let res = await this.$store.dispatch('poll/resultsXlsx', this.$route.params.id)

        // @ts-ignore
        windowReference.location = config(CONF_BASE_URL) + res.url;
      } catch (error) {
        console.error('LOG: getPollResults -> error', error)
        // @ts-ignore
        this.$message.error(this.$t('polls.can_not_download_results'))
      }
    }
  },
})
